export default {
    buttons: {
        change_role: 'Change role',
        delete_company_user: 'Delete company user',
        save: 'Save',
        add_user: 'Add user',
        show_user: 'Show on public pages',
        show_public_profile: 'Allow public profile preview',
    },
    fields: {
        company_role: {
            label: 'Company role',
            placeholder: 'Select company role',
        },
    },
}
